import { RichTextEditor as MantineRichTextEditor, RichTextEditorControlProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";
import { faListOl } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "../../icon";
import { useEditorDisabled } from "../use-editor-disabled";

const OrderedListIcon = () => <Icon icon={faListOl} size="xs" />;

export const OrderedList: FunctionComponent<RichTextEditorControlProps> = ({ className, disabled, ...other }) => {
    const effectiveDisabled = useEditorDisabled(disabled);
    return (
        <MantineRichTextEditor.OrderedList
            className={clsx(styles["control"], className)}
            disabled={effectiveDisabled}
            {...other}
            icon={OrderedListIcon}
        />
    );
};

OrderedList.displayName = "RichTextEditor.OrderedList";
